import React from 'react';
import { DropdownMenuMessage } from '../DropdownMenu/DropdownMenuMessage';
import { DropdownMenu, DropdownMenuProps } from '../DropdownMenu/DropdownMenu';
import { SelectSearchable, SelectSearchableVariant } from './Select';
import clsx from 'clsx';

export interface SelectDropdownProps extends Omit<DropdownMenuProps, 'after'> {
  searchable?: SelectSearchable;
  isOpen?: boolean;
  message?: string | null;
  classes?: {
    dropdownMenuMessage?: string;
  };
}

export const SelectDropdown = React.forwardRef<
  HTMLDivElement,
  SelectDropdownProps
>(
  (
    { className, classes, isOpen, message, searchable, children, ...props },
    ref
  ) => {
    return (
      <DropdownMenu
        ref={ref}
        className={clsx(
          'hse-Select__menu',
          {
            'hse-Select__menu_opened': isOpen
          },
          className
        )}
        borderless={
          !!message &&
          !children &&
          searchable === SelectSearchableVariant.inline
        }
        {...props}
      >
        {message ? (
          <DropdownMenuMessage
            className={clsx(classes?.dropdownMenuMessage, {
              SelectDropdown__message_searchable_dropdown:
                searchable === SelectSearchableVariant.dropdown
            })}
          >
            {message}
          </DropdownMenuMessage>
        ) : null}
        {children}
      </DropdownMenu>
    );
  }
);
